import { useAuth0 } from "@auth0/auth0-react";
import Button from "@mui/material/Button";
import { Container, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function Home() {
  const { loginWithRedirect } = useAuth0();

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        px: 2,
        py: 8,
        backgroundImage: (theme) =>
          theme.functions.linearGradient(
            theme.palette.gradients.primary.main,
            theme.palette.gradients.primary.state,
            160
          ),
      }}
    >
      {/* Decorative ambient glows */}
      <Box
        sx={{
          position: "absolute",
          top: "-15%",
          right: "-20%",
          width: 360,
          height: 360,
          borderRadius: "50%",
          background: (theme) =>
            theme.functions.rgba(theme.palette.secondary.main, 0.35),
          filter: "blur(80px)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "-20%",
          left: "-15%",
          width: 320,
          height: 320,
          borderRadius: "50%",
          background: (theme) =>
            theme.functions.rgba(theme.palette.white.main, 0.12),
          filter: "blur(70px)",
        }}
      />

      <Container maxWidth="xs" sx={{ position: "relative", zIndex: 1 }}>
        <Stack spacing={4} alignItems="center" textAlign="center">
          <Box
            sx={{
              width: 132,
              height: 132,
              borderRadius: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: (theme) =>
                theme.functions.rgba(theme.palette.white.main, 0.14),
              border: (theme) =>
                `1px solid ${theme.functions.rgba(
                  theme.palette.white.main,
                  0.35
                )}`,
              backdropFilter: "blur(6px)",
              boxShadow: "0 20px 50px -20px rgba(0,0,0,0.45)",
            }}
          >
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/iceman.svg`}
              alt="WRS Central"
              sx={{
                width: 92,
                filter: "brightness(0) invert(1)",
                opacity: 0.95,
              }}
            />
          </Box>

          <Box>
            <Typography
              variant="h3"
              sx={{
                color: "white.main",
                fontWeight: 800,
                letterSpacing: "-0.02em",
              }}
            >
              WRS Central
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                color: (theme) =>
                  theme.functions.rgba(theme.palette.white.main, 0.8),
                fontWeight: 400,
                mt: 0.5,
              }}
            >
              Sign in to manage your patients, prescribers, and inventory.
            </Typography>
          </Box>

          <Button
            fullWidth
            variant="contained"
            color="secondary"
            size="large"
            onClick={loginWithRedirect}
            sx={{
              py: 1.5,
              fontSize: "1rem",
              fontWeight: 700,
              boxShadow: "0 12px 30px -12px rgba(0,0,0,0.5)",
            }}
          >
            Log in
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
